module.exports = __webpack_public_path__ + "__assets__/img/wechat-code.c6358808.jpg";